(function () {
    'use strict';

    angular
        .module('app.alerts')
        .controller('PromoDetailController', PromoDetailController);

    PromoDetailController.$inject = [ '$state', '$stateParams',  'common', 'dataservice'];
    

    function PromoDetailController($state, $stateParams, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;

        vm.cancel = cancel;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.submitForm = submitForm;
        vm.isNew = isNew;

        activate();

        function activate() {
            getItem();
        }

        function submitForm(valid) {
            save();
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            window.history.back();
        }

      
        function isNew() {
            var val = $stateParams.id; 
            return val === "0";
                
        }

        function getItem() {
            var val = $stateParams.id;

            return dataservice.getItem("api/Promos/" + val)
                .then(function (data) {
                    if (data) {
                        if (data.data.ID == '0') {
                            vm.item = {};
                        }
                        else {
                            vm.item = data.data;
                        }
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function save() {
            vm.isSaving = true;
            dataservice.saveItem('api/Promos', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
